import { render, staticRenderFns } from "./EmailAnnotation.vue?vue&type=template&id=202e94fe&"
import script from "./EmailAnnotation.vue?vue&type=script&lang=js&"
export * from "./EmailAnnotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports